var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalcManLeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "51px",
    viewBox: "0 0 33 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CalcManLeg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CalcManLeg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.55060993,49.9265741 C4.87387452,52.1625012 -1.39438633,48.0746431 0.282349072,45.8396882 L5.73173915,38.5748693 L12,42.6617552 L6.55060993,49.9265741",
    id: "Fill-412",
    fill: "#A8ACBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,38.4384893 C6.58585859,25.685941 9.5959596,7.27195655 21.5555556,0 L32.0700214,2.57486933 C31.75689,3.50923236 34,9.57486933 30.2525253,14.4876504 L11.4646465,45.0955747 C7.65656566,47.3581398 2.52525253,41.0165275 2,38.4384893 Z",
    id: "Fill-413",
    fill: "#27427A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcManLeg);
export default __webpack_public_path__ + "static/media/CalcManLeg.2ed59f0cd9237596bae97eb5c0147030.svg";
export { ForwardRef as ReactComponent };